/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EditInputs */



/**
* | output |
* | --- |
* | "Edit" |
*
* @param {EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit = /** @type {((inputs?: EditInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EditInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Édition")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modificare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar")
	return /** @type {LocalizedString} */ ("Edit")
});